import instance from "../Config/Config"


export const login_url = "login"
export const signup_url = "signup"
export const delete_acc_url = "delete_request"
export const frgtpwd = "forgotPassword"
export const resetpwd = "resetPassword"
export const gender_url = "genders"
export const Testimonal = "testimonials"
export const setting = "setting"
export const role_url = "role"
export const COUNTRY_URL = "get_country"
export const STATE_URL = "get_state"
export const CITY_URL = "get_city"
export const PLANS = "plans"
export const REFERENCE = "reference"
export const PLAN_DETAIL = "detail"
export const TERM_DETAIL = "pages"
//added
export const CAPTURE_PAYMENT = "capture-payment"
export const PAY_COUPON = "pay_now_genrate_coupon"
export const GENERATE_COUPON = "genrate_coupon"
export const APPLY_COUPON = "generate_coupon_code"



//added
export const catalogue_fun = async () => {
    const response = await instance.get("get_catalogue")
    return response.data
}

export const Login_fun = async (value) => {
    const response = await instance.post(`${login_url}`, value)
    return response.data
}

export const Delete_account_fun = async () => {
    const response = await instance.get(`${delete_acc_url}`)
    return response?.data
}

export const Signup_fun = async (value) => {
    const response = await instance.post(`${signup_url}`, value);
    return response.data;
}

//added
export const capture_payment = async (value) => {
    const response = await instance.post(`${CAPTURE_PAYMENT}`, value)
    return response?.data
}

export const verify_pwd = async (value) => {
    const response = await instance.post(`${frgtpwd}`, value)
    return response.data
}

export const trestiAPi = async () => {
    const response = await instance.get(`${Testimonal}`)
    return response?.data
}

// export const reference_fun = async(value)=>{
//     const response = await instance.get(`${REFERENCE}`,value)
//     return response?.data
// }
// export const reference_fun = async (value) => {
//   const response = await instance.get(`${REFERENCE}`, {
//     params: value, 
//   });
//   return response?.data;
// };

export const reference_fun = async (user_id) => {

    const response = await instance.get(`${REFERENCE}`, {
        params: { user_id },
    });
    return response?.data;

};


export const resetpwd_fun = async (value) => {
    const response = await instance.post(`${resetpwd}`, value)
    return response.data
}





export const GenderApi = async () => {
    const response = await instance.get(`${gender_url}`)
    return response.data
}

export const getSettingApi = async () => {
    const response = await instance.get(`${setting}`)
    return response?.data
}

export const Country_fun = async () => {
    const response = await instance.get(`${COUNTRY_URL}`)
    return response?.data
}


//added for capture payment razarpay


export const State_fun = async (id) => {
    const response = await instance.get(`${STATE_URL}?country_id=${id}`)
    return response?.data
}

export const City_fun = async (country_id, state_id) => {
    const response = await instance.get(`${CITY_URL}?country_id=${country_id}&state_id=${state_id}`)
    return response?.data
}
export const schemeplans = async (id) => {
    const response = await instance.get(`${PLANS}?id=${id}`)
    return response?.data
}

export const getPlanDetail = async (slug) => {

    const plan_detail_url = `${PLAN_DETAIL}/${slug}`;

    const response = await instance.get(plan_detail_url)
    return response?.data
}


export const getTermsCondition = async (slug) => {

    const response = await instance.get(`${TERM_DETAIL}?slug=${slug}`)
    return response?.data
}



//added for coupon(gifts)

export const Buy_coupon = async (value) => {
    const response = await instance.post(`${PAY_COUPON}`, value)
    return response.data
}
export const generate_coupon = async () => {
    const response = await instance.get(`${GENERATE_COUPON}`)
    return response.data
}

export const apply_coupon = async (value) => {
    const response = await instance.get(`${APPLY_COUPON}?generate_coupon_code=${value}`)
    return response.data
}

